import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

class ExportButton extends React.Component {
  render() {
    const { className, title } = this.props;

    return (
      <a
        href="javascript:void(0);"
        className={className}
        onClick={this.handlerClick}
      >
        {title}
      </a>
    );
  }

  handlerClick = () => {
    const { url, location, search, accessLevel, formId, startDate, endDate } = this.props;
    const params = [];

    if (location) {
      params.push(`location_id=${location}`);
    }

    if (search) {
      params.push(`search=${search}`);
    }

    if (accessLevel) {
      params.push(`access_level=${accessLevel}`);
    }

    if (formId) {
      params.push(`form_id=${formId}`);
    }

    if (startDate) {
      params.push(`start_date=${startDate}`);
    }

    if (endDate) {
      params.push(`end_date=${endDate}`);
    }

    let requestUrl = url;
    if (params.length > 0) {
      requestUrl = `${url}?${params.join("&")}`;
    }

    axios
      .get(requestUrl)
      .then(() => {
        toastr.info('Your Excel Export will be generated shortly, an email with a link will be sent and the file will be available in your My Downloads.');
      })
      .catch(() => {
        toastr.error("Unable to export it at this time");
      });
  };
}

ExportButton.propsTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  search: PropTypes.string,
  location: PropTypes.string,
  accessLevel: PropTypes.string,
  formId: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

ExportButton.defaultProps = {
  title: "EXPORT"
};

export default ExportButton;
